/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { Pmo } from '@scenario/models/pmo.model';
import { RootState } from '@store/create-store';

export interface PmoMutation {
  pmo: Pmo;
  file?: File;
}

export interface PmoState {
  pmos: Pmo[];
  releases: string[];
  isFetching: boolean;
  isFetchingReleases: boolean;
  isSaving: boolean;
  error?: string;
}

const initialState: PmoState = {
  pmos: [],
  releases: [],
  isFetching: false,
  isFetchingReleases: false,
  isSaving: false,
};

export const pmoSlice = createSlice({
  name: 'pmo',
  initialState,
  reducers: {
    retrievePmos: state => {
      state.isFetching = true;
      state.error = undefined;
    },
    retrievePmosSuccess: (state, action: PayloadAction<Pmo[]>) => {
      state.pmos = action.payload;
      state.isFetching = false;
    },
    retrievePmosFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    retrieveReleases: state => {
      state.isFetchingReleases = true;
    },
    retrieveReleasesSuccess: (state, action: PayloadAction<string[]>) => {
      state.releases = action.payload;
      state.isFetchingReleases = false;
    },
    retrieveReleasesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetchingReleases = false;
    },
    createPmo: (state, _action: PayloadAction<PmoMutation>) => {
      state.isSaving = true;
      state.error = undefined;
    },
    updatePmo: (state, _action: PayloadAction<PmoMutation>) => {
      state.isSaving = true;
      state.error = undefined;
    },
    deletePmo: (state, _action: PayloadAction<number>) => {
      state.isSaving = true;
      state.error = undefined;
    },
    savePmoSuccess: state => {
      state.isSaving = false;
    },
    savePmoFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isSaving = false;
    },
  },
});

export type PmoViewModel = {
  pmos: Pmo[];
  releases: string[];
  isFetching: boolean;
  isSaving: boolean;
  error?: string;
};

export const selectPmoViewModel = createSelector(
  (state: RootState) => state,
  (state): PmoViewModel => ({
    pmos: state.pmo.pmos,
    releases: state.pmo.releases,
    isFetching: state.pmo.isFetching,
    isSaving: state.pmo.isSaving,
    error: state.pmo.error,
  }),
);

export const {
  createPmo,
  deletePmo,
  retrievePmos,
  retrievePmosFailure,
  retrievePmosSuccess,
  retrieveReleases,
  retrieveReleasesFailure,
  retrieveReleasesSuccess,
  savePmoFailure,
  savePmoSuccess,
  updatePmo,
} = pmoSlice.actions;

export default pmoSlice.reducer;



